export const navigationPaneScreenReaderOnlyText = "ycvULe";
export default {navigationPaneScreenReaderOnlyText};